import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ZuordnungWaermeerzeugerWarmwasserGwrWerte extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    zuordnung_waermeerzeuger_warmwasser_id: number | null = null;
    waermeerzeuger_warmwasser_id: number | null = null;
    energie_waermequelle_id: number | null = null;

    // view fields:
    energie_waermequelle_i18n_key: string | null = null;
    waermeerzeuger_warmwasser_i18n_key: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ZuordnungWaermeerzeugerWarmwasserGwrWerte';
    }
}

export async function createNewZuordnungWaermeerzeugerWarmwasserGwrWerte(): Promise<ZuordnungWaermeerzeugerWarmwasserGwrWerte> {
    const model = createModel(ZuordnungWaermeerzeugerWarmwasserGwrWerte, {});

    await model.save();
    return model;
}

export class ZuordnungWaermeerzeugerWarmwasserGwrWerteCollection extends BaseCollection<ZuordnungWaermeerzeugerWarmwasserGwrWerte> {
    protected modelCls = ZuordnungWaermeerzeugerWarmwasserGwrWerte;

    public getModelClassName(): string {
        return 'ZuordnungWaermeerzeugerWarmwasserGwrWerte';
    }
}
